{
  "version": 1,
  "asset_id": "8e4e1149-6c7d-4be6-94ba-348c7e90e75c",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/8e4e1149-6c7d-4be6-94ba-348c7e90e75c/plunkets-horizontal.png",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/8e4e1149-6c7d-4be6-94ba-348c7e90e75c/plunkets-horizontal.png",
  "original_filename": "plunkets-horizontal.png",
  "size": 43528,
  "content_type": "image/png",
  "created_at": "2026-06-30T19:57:53Z"
}
